import router from "@plugins/router";
import store from "@plugins/store";
import { i18n } from "@plugins/i18n";
import { vuetifyPlugin } from "@plugins/vuetify";
import Plugin from "@/plugins";
import { directivePlugin } from "@utils/directives";
import VueGtag from "vue-gtag-next";
import appConfigs from "@configs/app";
import pinia from "@plugins/pinia";

const AppInstanceUtils = {
  installCommonPlugin(appInstance) {
    appInstance.use(router);
    appInstance.use(store);
    appInstance.use(pinia);
    appInstance.use(i18n);
    appInstance.use(vuetifyPlugin);
    appInstance.use(Plugin);
    appInstance.config.globalProperties.$i18n = i18n.global;
    appInstance.use(directivePlugin);
    appInstance.use(VueGtag, {
      config: { id: appConfigs.googleAnalyticsMeasurementId },
    });

    appInstance.mixin({
      mounted() {
        this.$el.__vue__ = this; // Or __vue__ for backwards compatibility.
      },
    });
  },
  generateDynamicMountProps(parentComponent) {
    return {
      dynamicMountChildMixin_parentComponent: parentComponent,
      dynamicMountChildMixin_isDynamicallyMounted: true,
    };
  },
  unmountFromComponent(component) {
    if (!component || !component.$ || component.$.isUnmounted) {
      return;
    }
    component.$.appContext.app.unmount();
  },
};

export default AppInstanceUtils;
